/**
 * Filter Configuration
 * Centralized filter options for submissions, jobs, candidates
 */

// Submission status filter options
export const submissionStatusGroups = [
  {
    label: '⚡ Active Pipeline (default)',
    options: [
      { value: 'submission', label: 'Submission' },
      { value: 'client submission', label: 'Client Submission' },
      { value: 'interview', label: 'Interview' },
      { value: 'offer extended', label: 'Offer Extended' },
      { value: 'offer accepted', label: 'Offer Accepted' },
      { value: 'onboarding', label: 'Onboarding' }
    ]
  },
  {
    label: 'Completed States',
    options: [
      { value: 'onboarded', label: 'Onboarded', badge: '(past)' }
    ]
  },
  {
    label: 'Rejection Stages',
    options: [
      { value: 'rejected', label: 'Rejected' },
      { value: 'interview rejected', label: 'Interview Rejected' },
      { value: 'offer rejected', label: 'Offer Rejected' },
      { value: 'candidate lost', label: 'Candidate Lost' }
    ]
  }
];

// Job status filter options (Juno Schema)
export const jobStatusGroups = [
  {
    label: '⚡ Action Required (default selected)',
    options: [
      { value: 'accepting_candidates', label: 'Accepting Candidates' },
      { value: 'interviewing', label: 'Interviewing' }
    ]
  },
  {
    label: 'Other Active States',
    options: [
      { value: 'covered', label: 'Covered' },
      { value: 'offer_out', label: 'Offer Out' }
    ]
  },
  {
    label: 'Closed/Inactive States',
    options: [
      { value: 'filled', label: 'Filled', badge: '(closed)' },
      { value: 'on_hold', label: 'On Hold', badge: '(closed)' },
      { value: 'cancelled', label: 'Cancelled', badge: '(closed)' },
      { value: 'lost', label: 'Lost', badge: '(closed)' },
      { value: 'declined', label: 'Declined', badge: '(closed)' }
    ]
  }
];

// Helper to generate client filter groups
export const generateClientGroups = (clients) => {
  if (!clients || clients.length === 0) {
    return [];
  }

  return [{
    label: null,
    options: clients.map(client => ({
      value: client,
      label: client
    }))
  }];
};
